import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-apollo";
import { Button, Form, Modal } from "react-bootstrap";
import * as yup from 'yup';
import { CREATE_FARM, GET_GROWERS2 } from "../../../../../queries";
import { GetGrowers } from "../../../../../__generated__/types";
import { useStore } from "../../../providers/AppProvider";
import { Grower } from "../../../types/types";

type CreateFarmProps = {
    isOpen: boolean,
    onClose: (growerId?: number) => void;
}

const schema = yup.object().shape({
    name: yup.string().required(),
    description: yup.string(),
    grower_id: yup.number().required('grower is required'),
});

export const CreateFarm = ({ isOpen, onClose }:CreateFarmProps) => {
    const { orgId } = useStore();

    const [growers, setGrowers] = useState<Grower[]>([]);

    const {data: growerData, loading} = useQuery<GetGrowers>(GET_GROWERS2);

    const [createFarm] = useMutation(CREATE_FARM, {
        awaitRefetchQueries: true,
        refetchQueries: [
            'GetFarms'
        ],
    });

    useEffect(() => {
        setGrowers(growerData ? growerData.landscan_growers.map(g => { 
            return {
            id: g.grower_id,
            name: g.name,
            description: g.description
        } as Grower
    }) : []);
    }, [growerData]);
    
    if(loading) {
        return <div>loading...</div>
    }

    return (
        <Modal show={isOpen} onHide={() => onClose()}>
                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        name: "",
                        description: "",
                        grower_id: ""
                    }}
                    validationSchema={schema}
                    validateOnChange={false}
                    validateOnBlur={false}
                    onSubmit={async (values, { setSubmitting, resetForm }) => {
                        setSubmitting(true);
                        const inputs = { org_id: orgId, grower_id: values.grower_id, name: values.name, description: values.description };
                        await createFarm({ variables: { data: inputs } } );
                        setSubmitting(false);
                        onClose(parseInt(values.grower_id));
                    }}
                >
                    {({
                        values,
                        errors,
                        handleChange,
                        handleBlur,
                        handleSubmit
                    }) => {
                        return (
                            <Form noValidate onSubmit={handleSubmit} autoComplete="off">
                                 <Modal.Header closeButton>
                                    <Modal.Title>Add a Farm</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div>
                                    <Form.Group controlId="formRole">
                                        <Form.Label className="d-flex justify-content-between">
                                            Grower
                                        </Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="grower_id"
                                            value={values.grower_id}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.grower_id}
                                            onChange={handleChange}
                                        >
                                            <option value="" label="Select a grower" disabled />
                                            {growers.map(option => {
                                                return <option key={option.id} value={option.id}>{option.name}</option>
                                            })}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.grower_id}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    </div>
                                    <div>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                placeholder="Enter name"
                                                value={values.name}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.name}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.name}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Description</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="description"
                                                placeholder="Enter description"
                                                value={values.description}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.description}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.description}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <div className="d-flex justify-content-between">
                                        <div className="d-flex gap-2">
                                            <Button variant="primary" type="submit">
                                                Create
                                            </Button>
                                            <Button variant="secondary" className="mx-2"  onClick={() => onClose()}>
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>
                                </Modal.Footer>
                            </Form>
                        );
                    }}
                </Formik>
        </Modal>
    );
};

